// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Topics = {
  topicsHash: null,
  error: null,
  topicsFetched: false,
};
